import {
    defineMessages
} from 'react-intl';

export default defineMessages({
    /**
     * Messages used in the *.metadata.json5
     */
    incorrectLossEstimatateId: {
        id: 'fnol.common.sasria-vehicle-incident.incorrectLossEstimatateId',
        defaultMessage: 'Loss Estimate is invalid'
    },
    incorrectLossEstimatateMessage: {
        id: 'nol.common.sasria-vehicle-incident.incorrectLossEstimatateMessage.',
        defaultMessage: 'Loss Estimate is an Amount field and cannot accept alphanumeric values and it must be a money value, with a maximum of 16 digits to the left and 2 digits to the right of the decimal separator'
    },

    vinAndEngineNoValidationId: {
        id: 'fnol.common.sasria-vehicle-incident.vinAndEngineNoValidationId',
        defaultMessage: 'Mandatory Field validation failed'
    },
    vinAndEngineNoValidationMessage: {
        id: 'nol.common.sasria-vehicle-incident.vinAndEngineNoValidationMessage.',
        defaultMessage: 'Vin Number and Engine Number is mandatory if Assessor code is selected as Yes'
    },

    lossEstimateValidationId: {
        id: 'fnol.common.sasria-vehicle-incident.lossEstimateValidationId',
        defaultMessage: 'Mandatory Field validation failed'
    },
    lossEstimateValidationMessage: {
        id: 'nol.common.sasria-vehicle-incident.lossEstimateValidationMessage.',
        defaultMessage: 'Loss Estimate is required when "Do you have a Loss Estimate?" is selected as Yes'
    },
    regNoValidationId: {
        id: 'fnol.common.sasria-vehicle-incident.regNoValidationId',
        defaultMessage: 'Mandatory Field validation failed'
    },
    regNoValidationMessage: {
        id: 'fnol.common.sasria-vehicle-incident.regNoValidationMessage.',
        defaultMessage: 'Vehicle Reg No is a mandatory field'
    },
    deletionIncidentTitle: {
        id: 'fnol.common.sasria-vehicle-incident.Incident deletion may have failed',
        defaultMessage: 'Incident deletion may have failed'
    },
    deletionIncidentFailedMessage: {
        id: 'fnol.common.sasria-vehicle-incident.Something may have gone wrong trying to delete the incident.',
        defaultMessage: 'Something may have gone wrong trying to delete the incident.'
    },
    removeIncidentFailedTitle: {
        id: 'fnol.common.sasria-vehicle-incident.Incident deletion failed',
        defaultMessage: 'Incident deletion failed'
    },
    removeIncidentFailedMessage: {
        id: 'fnol.common.sasria-vehicle-incident.Sorry the incident could not be deleted at this time',
        defaultMessage: 'Sorry the incident could not be deleted at this time'
    },
    duplicateVehicleAddedTitle: {
        id: 'fnol.common.sasria-vehicle-incident.Duplicate Vehicle Added',
        defaultMessage: 'Duplicate Vehicle Added'
    },
    duplicateVehicleAddedMessage: {
        id: 'fnol.common.sasria-vehicle-incident.This vehicle has already been added from dropdown',
        defaultMessage: 'This vehicle has already been added from dropdown.'
    },

    duplicateVehicleCardAddedMessage: {
        id: 'fnol.common.sasria-vehicle-incident.This vehicle has already been added in Incident Card',
        defaultMessage: 'This vehicle has already been added in Incident Card.'
    },

    noVehicleDataFoundTitle: {
        id: 'fnol.common.sasria-vehicle-incident.No vehicle found',
        defaultMessage: 'No Vehicle found.'
    },

    noVehicleDataFoundMessage: {
        id: 'fnol.common.sasria-vehicle-incident.No Vehicle found with this combination of MmCode and Year',
        defaultMessage: 'No Vehicle found with this  combination of MmCode and Year'
    },

    assessorsCodeSelectionValidationId: {
        id: 'fnol.common.sasria-vehicle-incident.assessorsCodeSelectionValidationId',
        defaultMessage: 'Mandatory Field validation failed'
    },
    assessorsCodeSelectionValidationMessage: {
        id: 'fnol.common.sasria-vehicle-incident.assessorsCodeSelectionValidationMessage.',
        defaultMessage: '"Do you have  an Assessors Report?" is mandatory'
    },

    lossEstimateSelectionValidationId: {
        id: 'fnol.common.sasria-vehicle-incident.lossEstimateSelectionValidationId',
        defaultMessage: 'Mandatory Field validation failed'
    },
    lossEstimateSelectionValidationMessage: {
        id: 'fnol.common.sasria-vehicle-incident.lossEstimateSelectionValidationMessage.',
        defaultMessage: '"Do you have a Loss Estimate?" is mandatory'
    },

    possibleTotalLossSelectionValidationId: {
        id: 'fnol.common.sasria-vehicle-incident.possibleTotalLossSelectionValidationId',
        defaultMessage: 'Mandatory Field validation failed'
    },
    possibleTotalLossSelectionValidationMessage: {
        id: 'fnol.common.sasria-vehicle-incident.possibleTotalLossSelectionValidationMessage.',
        defaultMessage: '"Possible Total Loss?" is mandatory'
    },
    passportNoValidationTitle: {
        id: 'fnol.common.policy-vehicle-incident.passportNoValidationTitle',
        defaultMessage: 'Passport Number validation has failed'
    },
    passportNoValidationMessage: {
        id: 'nol.common.policy-vehicle-incident.passportNoValidationMessage.',
        defaultMessage: 'Passport Number must be less than 13 digits and aplha numeric with no spaces.'
    },
    idNoValidationTitle: {
        id: 'fnol.common.policy-vehicle-incident.idNoValidationTitle',
        defaultMessage: 'Identity Number validation has failed'
    },
    idNoValidationMessage: {
        id: 'nol.common.policy-vehicle-incident.idNoValidationMessage.',
        defaultMessage: 'Identity Number must be 13 digit numeric number with no spaces(YYMMDDNNNNNNN).It is a mandatory field.'
    },
});